<script setup>
import { useAuthStore, useReadinessStore } from '../stores';
import { onMounted, ref } from 'vue'
const firstName = ref('')
const lastName = ref('')
const email = ref('')
const show = ref(false)

const authStore = useAuthStore()
const readinessStore = useReadinessStore()

if (authStore.authToken && !authStore.user) {
  await authStore.hydrateAccount()
}

onMounted(() => {
  firstName.value = authStore.user.first_name
  lastName.value = authStore.user.last_name
  email.value = authStore.user.email
  readinessStore.fetchReadinessGuides()
})

</script>
<template>
  <div class="flex flex-col items-end">
    <button type="button" @click="show = !show"
      class="flex flex-col mr-3 text-lg bg-teal-400 text-white rounded-full md:mr-0 focus:ring-4 focus:ring-gray-300 align-center"
      id="user-menu-button" aria-expanded="false" data-dropdown-toggle="user-dropdown" data-dropdown-placement="bottom">
      <span class="sr-only">Open user menu</span>
      <div class="w-12 h-12 rounded-full text-lg font-semibold align-text-bottom flex flex-col justify-center items-center" src="/vite.svg" alt="user photo">
        <div>
          {{ `${firstName[0]}. ${lastName[0]}.` }}
        </div>
      </div>
    </button>
    <div
      :class="show ? '': 'hidden'"
      class="z-50 mt-10 mr-12 text-base right-0 list-none absolute  bg-white divide-y divide-gray-100 rounded-lg shadow "
      id="user-dropdown">
      <div class="px-4 py-3">
        <span class="block text-sm text-white">{{ `${firstName}
                ${lastName[0]}.` }}</span>
        <span class="block text-sm  text-gray-500 truncate ">{{ email }}</span>
      </div>
      <ul class="py-2" aria-labelledby="user-menu-button">
        <li>
          <a href="#"
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Profile</a>
        </li>
        <!-- <li>
          <a href="#"
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Settings</a>
        </li> -->
        <li>
          <router-link :class="`block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white`" to="/account/family"> Family
          </router-link>
        </li>
        <li>
          <a href="#" @click="authStore.logout()"
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Sign
            out</a>
        </li>
      </ul>
    </div>
  </div>
</template>